import { render, staticRenderFns } from "./WaitingView.vue?vue&type=template&id=5031b764"
import script from "./WaitingView.vue?vue&type=script&lang=js"
export * from "./WaitingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5031b764')) {
      api.createRecord('5031b764', component.options)
    } else {
      api.reload('5031b764', component.options)
    }
    module.hot.accept("./WaitingView.vue?vue&type=template&id=5031b764", function () {
      api.rerender('5031b764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/WaitingView.vue"
export default component.exports